export default __webpack_public_path__ + "static/media/project3.cca1a4d0.png";